import { render, staticRenderFns } from "./WhatsappSetupPaths.vue?vue&type=template&id=d0a005ee&scoped=true&"
import script from "./WhatsappSetupPaths.vue?vue&type=script&lang=js&"
export * from "./WhatsappSetupPaths.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappSetupPaths.vue?vue&type=style&index=0&id=d0a005ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a005ee",
  null
  
)

export default component.exports